import { useMutation } from '@tanstack/react-query';
import { postManualCallback } from 'services/api/postManualCallback';

export const useManualCallback = () => {
    const { mutateAsync, ...rest } = useMutation({
        mutationFn: postManualCallback,
        retry: 2,
    });

    return { initiateManualCallback: mutateAsync, ...rest };
};
